import script from "./Timeline.vue?vue&type=script&setup=true&lang=js"
export * from "./Timeline.vue?vue&type=script&setup=true&lang=js"

import "./Timeline.vue?vue&type=style&index=0&id=cae52948&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cae52948"]])

export default __exports__